const NE_POOLING_LABELS_TIMEOUT = 60000;
const NE_POOLING_LABELS_INTERVAL = 5000;

export { NE_POOLING_LABELS_TIMEOUT, NE_POOLING_LABELS_INTERVAL };
